<template>
    <h1>Erro 404</h1>
</template>

<script>
    export default{
        name: 'Error404View',
    }
</script>